// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/";
const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "login"),
  register: path(ROOTS_AUTH, "register"),
  verification: path(ROOTS_AUTH, "verification"),
  resetPassword: path(ROOTS_AUTH, "reset-password"),
  kycUpload: path(ROOTS_AUTH, "kyc-upload"),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    dashboard: path(ROOTS_DASHBOARD, "/"),

    // =============== no use  ================
    authUsers: path(ROOTS_DASHBOARD, "/auth-users"),
    regUsers: path(ROOTS_DASHBOARD, "/reg-users"),
    regUserEdit: path(ROOTS_DASHBOARD, "/reg-user-edit"),

    authUserEdit: path(ROOTS_DASHBOARD, "/auth-user-edit"),

    rolePermission: path(ROOTS_DASHBOARD, "/role-permission"),
    permission: path(ROOTS_DASHBOARD, "/permission"),

    category: path(ROOTS_DASHBOARD, "/category"),
    mainCategory: path(ROOTS_DASHBOARD, "/main-category"),
    vendor: path(ROOTS_DASHBOARD, "/vendor"),
    getProfile: path(ROOTS_DASHBOARD, "/getProfile"),

    changePassword: path(ROOTS_DASHBOARD, "/changePassword")

  },
};

export const FOOD_ITEMS = {
  root: ROOTS_DASHBOARD,
  general: {
    foodItem: path(ROOTS_DASHBOARD, "/food-item"),
    foodCategory: path(ROOTS_DASHBOARD, "/food-category"),
    foodMenu: path(ROOTS_DASHBOARD, "/food-menu"),
  }
}

export const GROCERY_ITEMS = {
  root: ROOTS_DASHBOARD,
  general: {
    grocerCategory: path(ROOTS_DASHBOARD, "/grocery-category"),
    groceryItem: path(ROOTS_DASHBOARD, "/grocery-item"),
    groceryMenu: path(ROOTS_DASHBOARD, "/grocery-menu")
  }
}

export const ORDER = {
  root: ROOTS_DASHBOARD,
  general: {
    order: path(ROOTS_DASHBOARD, "/order"),
    orderDetails: path(ROOTS_DASHBOARD, "/order-details"),
    pendingOrder: path(ROOTS_DASHBOARD, "/pending-order"),
    completedOrder: path(ROOTS_DASHBOARD, "/completed-order"),
    cancelledOrder: path(ROOTS_DASHBOARD, "/cancelled-order"),
    disputedOrder: path(ROOTS_DASHBOARD, "/disputed-order"),
  }
}

export const PAYOUT = {
  root: ROOTS_DASHBOARD,
  general: {
    pendingPayout: path(ROOTS_DASHBOARD, "/my-payout"),
    completedPayout: path(ROOTS_DASHBOARD, "/completed-payout"),
    transactionList: path(ROOTS_DASHBOARD, "/transactions-list"),
  }
}
export const ADVERTISEMENT = {
  root: ROOTS_DASHBOARD,
  general: {
    advertisement: path(ROOTS_DASHBOARD, "/advertisement"),
  }
}

export const SUPPORT_PATH = {
  root: ROOTS_DASHBOARD,
  general: {
    supportTicket: path(ROOTS_DASHBOARD, "/support-ticket"),
    feedBackRating: path(ROOTS_DASHBOARD, "/feedback-rating"),
    viewSupportRequest: path(ROOTS_DASHBOARD, "/view-support-request"),
    editSupportRequest: path(ROOTS_DASHBOARD, "/edit-support-request"),
  }
}
export const SETTING_PATH = {
  root: ROOTS_DASHBOARD,
  general: {
    twoFactor: path(ROOTS_DASHBOARD, "/twoFactorAuthentication"),
    bankDetail: path(ROOTS_DASHBOARD, "/bank-detail")
  }
}
export const EVENTS = {
  root: ROOTS_DASHBOARD,
  general: {
    eventList: path(ROOTS_DASHBOARD, "/event-list"),
    bookedTickets: path(ROOTS_DASHBOARD, "/booked-tickets"),
    pendingTickets: path(ROOTS_DASHBOARD, "/pending-tickets"),
  }
}
export const TRAVEL = {
  root: ROOTS_DASHBOARD,
  general: {
    travelmenu: path(ROOTS_DASHBOARD, "/travel-menu")
  }
}
export const NGO = {
  root: ROOTS_DASHBOARD,
  general: {
    ngomenu: path(ROOTS_DASHBOARD, "/ngo-menu"),
    charityTransaction: path(ROOTS_DASHBOARD, "/charity-transaction")
  }
}

export const SUB_VENDOR = {
  root: ROOTS_DASHBOARD,
  general: {
    subVendor: path(ROOTS_DASHBOARD, "/sub-vendor")
  }
}

export const ROLE_PERMISSION = {
  root: ROOTS_DASHBOARD,
  general: {
    role: path(ROOTS_DASHBOARD, "/role-permission"),
  }
}

export const HOME_PAGE_PATH = {
  root: ROOTS_AUTH,
};

export const PATH_DOCS = "https://docs-minimals.vercel.app/introduction";
